import script from "./whGOnceImg1.vue?vue&type=script&setup=true&lang=js"
export * from "./whGOnceImg1.vue?vue&type=script&setup=true&lang=js"

import "./whGOnceImg1.vue?vue&type=style&index=0&id=17d98810&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17d98810"]])

export default __exports__